import { useQuery } from '@tanstack/react-query';
import { configApi } from '@/api/config';

/**
 * Reads the effective `portalMagicLink` feature flag from `GET /config`
 * (shares the ['config'] cache with useRemoteHandoverSigning).
 *
 * Fail-closed: while loading, on error, and on refetch errors it returns
 * `false` — the OTP flow always works, so a config outage must degrade to it,
 * never strand the customer on a link-only screen. Note the join page mostly
 * branches on the portal-join RESPONSE status (authoritative, no drift); this
 * flag is only consulted where no response is available (the 429-cooldown
 * path, where the server tells us nothing about which mode it is in).
 */
export function usePortalMagicLink(): boolean {
  const { data, isError } = useQuery({
    queryKey: ['config'],
    queryFn: () => configApi.getPublicConfig().then((r) => r.data),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    retry: 1,
  });
  return isError ? false : (data?.portalMagicLink ?? false);
}
